import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MarginItem } from '../../types';
import { exchangeMarginsApi } from '../services';

export interface SidepanelMarginState {
  isLoading: boolean;
  panelIsOpen: boolean;
  marginId?: string;
  requestInProgress: boolean;
  marginValues?: MarginItem;
}

const initialState: SidepanelMarginState = {
  isLoading: false,
  panelIsOpen: false,
  requestInProgress: false,
};

export const sidepanelMarginSlice = createSlice({
  name: 'sidepanelMargin',
  initialState,
  reducers: {
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
    setMarginId: (state, action: PayloadAction<string>) => {
      state.marginId = action.payload;
    },
    clearSidepanelMarginState: (state) => {
      state.isLoading = false;
      state.panelIsOpen = false;
      state.requestInProgress = false;
      state.marginValues = undefined;
      state.marginId = undefined;
    },
    setMarginIsCustom: (state) => {
      if (state.marginValues) {
        state.marginValues = {
          ...state.marginValues,
          isCustom: true,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getDefaultMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        if (state.marginId === 'all') {
          state.marginValues = action.payload.data;
        }
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.getMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        state.marginValues = {
          ...action.payload.data,
          targetAccountGainsId: action.payload.data.targetAccountGainsId || '',
          targetAccountLossesId:
            action.payload.data.targetAccountLossesId || '',
        };
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.updateDefaultMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        state.marginValues = action.payload.data;
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.updateMargin.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        state.marginValues = action.payload.data;
      },
    );
    builder.addMatcher(
      exchangeMarginsApi.endpoints.restoreToDefault.matchFulfilled,
      (state, action: PayloadAction<{ data: MarginItem }>) => {
        state.marginValues = action.payload.data;
      },
    );
  },
});

export const {
  changePanelState,
  clearSidepanelMarginState,
  setMarginIsCustom,
  setMarginId,
} = sidepanelMarginSlice.actions;

export default sidepanelMarginSlice.reducer;
